import React from 'react'

export const TemplateValeListHead = () => {
  return (
    <thead>
      <tr>
        <th>Value</th>
      </tr>
    </thead>
  )
}
